exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".login-form {\n  max-width: 300px;\n  width: 300px;\n}\n.login-form-forgot {\n  float: right;\n}\n.ant-col-rtl .login-form-forgot {\n  float: left;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader!./components/UserInfo/style.css
// module id = 1889
// module chunks = 33